import i18n from './i18n';

// Below helps in spliting the string using : special character from app-config
export const trans = (word) => {
  if (word && typeof word === 'string') {
    return word.split(':');
  }
  return word;
};

export const getTrans = (label) => {
  if (label) {
    const wordArray = trans(label);
    return i18n.exists(wordArray[0]) ? i18n.t(wordArray[0]) : wordArray[1];
  } else return label;
};
